import React from 'react';
import {
  useGetJobsiteCardFormatsQuery,
  WorkerCardType,
} from 'apollo/generated/client-operations';
import { SelectOptionElement } from '@odin-labs/components';
import { ApolloError } from '@apollo/client';
import { getWorkerCardFormatOptions } from './utils';

export function usePvcCardFormatOptions(jobsiteId: string): {
  pvcCardFormatOptions: SelectOptionElement[];
  error: ApolloError;
} {
  const { data: getJobsiteCardFormatsData, error } =
    useGetJobsiteCardFormatsQuery({
      fetchPolicy: 'no-cache',
      skip: !jobsiteId,
      variables: { jobsiteId },
    });

  const { pvcCardFormatOptions } = React.useMemo(() => {
    const pvcCardFormats =
      getJobsiteCardFormatsData?.getJobsite?.jobsiteCardFormats.edges
        .map(({ node }) => node.workerCardFormat)
        .filter(
          (workerCardFormat) =>
            workerCardFormat?.cardType === WorkerCardType.Pvc,
        );
    return {
      pvcCardFormatOptions: getWorkerCardFormatOptions(pvcCardFormats),
    };
  }, [getJobsiteCardFormatsData]);

  return {
    pvcCardFormatOptions,
    error,
  };
}
